
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-0.857 -0.551 27.426 26.816","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M10.09 10.12v3.27l2.91 2.9v-3.42h3.29l-2.79-2.75h-3.41z","id":"a"}}),_c('path',{attrs:{"d":"M14.37 17.66l5.63 5.6h3.55v-3.21l-5.87-5.81h-3.31v3.42z","id":"b"}}),_c('path',{attrs:{"d":"M11.91 18.68c-3.82 0-7.07-3.14-7.07-7.22 0-4.07 3.21-7.15 7.07-7.15 3.86 0 6.93 3.08 6.93 7.15 0 .66-.08 1.3-.23 1.91.35.35 3.18 3.18 3.54 3.53.91-1.59 1.42-3.45 1.42-5.47C23.57 5.15 18.56.45 11.84.45 5.16.45.14 5.12.14 11.43c0 6.35 5.02 11.11 11.7 11.11 1.73 0 3.34-.31 4.78-.89-.63-.63-2.52-2.52-3.16-3.15-.5.12-1.01.18-1.55.18z","id":"c"}})]),_c('use',{attrs:{"xlink:href":"#a","fill-opacity":".7"}}),_c('use',{attrs:{"xlink:href":"#a","fill-opacity":"0","stroke":"#000","stroke-opacity":"0"}}),_c('use',{attrs:{"xlink:href":"#b","fill-opacity":".7"}}),_c('use',{attrs:{"xlink:href":"#b","fill-opacity":"0","stroke":"#000","stroke-opacity":"0"}}),_c('g',[_c('use',{attrs:{"xlink:href":"#c","fill-opacity":".7"}}),_c('use',{attrs:{"xlink:href":"#c","fill-opacity":"0","stroke":"#000","stroke-width":"0","stroke-opacity":"0"}})])])
          )
        }
      }
    